import * as React from 'react';
import * as microsoftTeams from "@microsoft/teams-js";
import { Box, Card, Flex, Menu, Text, tabListBehavior, ProviderConsumer as FluentUIThemeConsumer } from "@fluentui/react-northstar";
import PieChart from "../../chart/charts/pie";
import './visao-geral-atendimentos-status.scss';
import { withTranslation, WithTranslation } from "react-i18next";
import { TFunction } from "i18next";
import LoaderCharts from "../../loaders/loaderCharts";

export interface IVisaoGeralAtendimentosState {
    activeTabId: number;
    metrics: any;
    chartData: any;
    loading: boolean;
}


interface IVisaoGeralAtendimentosProps extends WithTranslation {
    metrics: any;
    index: number;
    filter: any;
    collapseCharts: Function;
    collapsed: boolean;
}

interface ITaskInfo {
    title?: string;
    height?: number;
    width?: number;
    url?: string;
    card?: string;
    fallbackUrl?: string;
}

class VisaoGeralAtendimentosPorStatus extends React.Component<IVisaoGeralAtendimentosProps, IVisaoGeralAtendimentosState> {
    private localize: TFunction;

    constructor(props: IVisaoGeralAtendimentosProps) {
        super(props);
        this.localize = this.props.t;

        this.state = {
            activeTabId: 0,
            metrics: this.props.metrics,
            chartData: {
                labels: [`${this.localize("AtendimentosRealizados")}`, `${this.localize("AtendimentosExpirados")}`, `${this.localize("AguardandoAtendimento")}`],
                datasets: [
                    {
                        data: [
                            this.parseMetrics(this.props.metrics).atendimentosRealizados,
                            this.parseMetrics(this.props.metrics).atendimentosAguardando,
                            this.parseMetrics(this.props.metrics).atendimentosCancelados,
                        ],
                    },
                ],
            },
            loading: false,
        }
    }

    public componentDidMount() {
        microsoftTeams.initialize();
    }

    componentDidUpdate(prevProps: any, prevState: any) {
        if (prevProps.metrics !== this.props.metrics) {
            this.setState({
                activeTabId: this.props.index,
                chartData: {
                    labels: [`${this.localize("AtendimentosRealizados")}`, `${this.localize("AtendimentosExpirados")}`, `${this.localize("AguardandoAtendimento")}`],
                    datasets: [
                        {
                            data: [
                                this.parseMetrics(this.props.metrics).atendimentosRealizados,
                                this.parseMetrics(this.props.metrics).atendimentosAguardando,
                                this.parseMetrics(this.props.metrics).atendimentosCancelados,
                            ],
                        },
                    ],
                }
            })
        }
    }

    public formatDataNumber(number: number) {
        if (number)
            return new Intl.NumberFormat('pt-BR').format(number)
        else
            return 0
    }

    public parseMetrics = (metricsData?: any) => {
        return {
            atendimentosRealizados: Math.round(metricsData?.percentRealizados * 100),
            atendimentosCancelados: Math.round(metricsData?.percentExpiradosCancelados * 100),
            atendimentosAguardando: Math.round(metricsData?.percentAguardandoAtendimento * 100),
        }
    }

    public setActiveTabId(index: number, item: any) {
        let selected = isNaN(item.content.split(" ")[0]) ? 0 : parseInt(item.content.split(" ")[0]);
        this.props.filter(selected, index).then((res: any) => this.setState({ loading: false }));

        this.setState({
            activeTabId: index
        })
    }

    public render() {
        let noData = false;

        if (this.props.metrics?.percentRealizados == 0 &&
            this.props.metrics?.percentExpiradosCancelados == 0 &&
            this.props.metrics?.percentAguardandoAtendimento == 0) {
            noData = true;
        }

        return (
            <Box
                className="visao-geral-atendimentos"
                styles={{
                    display: "grid",
                    gridGap: ".5rem",
                    gridTemplate:
                        "repeat(auto-fill, 2rem) / repeat(auto-fill, minmax(35rem, 1fr))",
                    gridAutoFlow: "dense",
                    gridAutoRows: this.props.collapsed ? "15rem 2rem" : "23rem 2rem",
                    padding: ".5rem",
                    minWidth: "20rem",
                    "@media (max-width: 986px)": {
                        gridTemplate:
                            "repeat(auto-fill, 25rem) / repeat(auto-fill, minmax(15.75rem, 1fr))",
                    },
                }}
            >
                <Card.Header>
                    <Flex gap="gap.small" space="between" style={{ minHeight: "2rem" }}>
                        <Flex gap="gap.small" column>
                            <Text content={this.localize("VisaoGeralAtendimentos")} style={{ margin: 0 }} weight="bold" />
                        </Flex>
                    </Flex>
                </Card.Header>
                <Card.Body
                    style={{
                        marginBottom: "0.75rem",
                        height: "100%",
                        overflow: "hidden",
                    }}
                    fitted
                >
                    {this.props.metrics ?
                        <>
                            <Menu
                                hidden={this.props.collapsed}
                                className="tabList"
                                style={{
                                    border: "none",
                                    background: "none",
                                    marginBottom: "1.25rem",
                                }}
                                items={[
                                    {
                                        key: "1",
                                        content: this.localize("TabHoje")
                                    },
                                    {
                                        key: "7",
                                        content: this.localize("7dias")
                                    },
                                    {
                                        key: "30",
                                        content: this.localize("30dias")
                                    },
                                    {
                                        key: "60",
                                        content: this.localize("60dias")
                                    }
                                ]}
                                activeIndex={this.props.index}
                                onItemClick={(currentTarget, props) => {
                                    this.setState({ loading: true });
                                    this.setActiveTabId(props && props.index ? props.index : 0, props);
                                }}
                                accessibility={tabListBehavior}
                                underlined
                                primary
                            />

                            {this.state.loading ? <LoaderCharts visaoGeralUnidades={true} /> :
                                <Flex gap="gap.medium">
                                    <Flex className={this.props.collapsed ? "chartVisaoGeral collapsed" : "chartVisaoGeral"}>
                                        {noData &&
                                            <Flex column className={this.props.collapsed ? "emptyData collapsed" : "emptyData"}>
                                                <Flex vAlign="center" hAlign="center">
                                                    <svg viewBox="0 0 64 64" className="emptyPie">
                                                        <circle r="25%" cx="50%" cy="50%" style={{ strokeDasharray: "75.3 100" }}>
                                                        </circle>
                                                        <circle r="25%" cx="50%" cy="50%" style={{ strokeDasharray: "19.9 100", stroke: "#D1D2D4", strokeDashoffset: "-75.3", animationDelay: "0.25s" }} >
                                                        </circle>
                                                    </svg>
                                                </Flex>

                                                <Flex className="emptyLabel" vAlign="center" hAlign="center">
                                                    <Text size="smaller" weight="bold" content={this.localize("NaoExistemAtendimentos")} styles={{ color: "rgb(138, 138, 138)" }} />
                                                </Flex>
                                            </Flex>
                                        }

                                        {!noData &&
                                            <FluentUIThemeConsumer
                                                render={(globalTheme) => {
                                                    return (
                                                        <PieChart
                                                            {...{
                                                                title: this.localize("VisaoGeralAtendimentos"),
                                                                data: this.state.chartData,
                                                                siteVariables: globalTheme.siteVariables,
                                                            }}
                                                        />
                                                    )
                                                }}
                                            />
                                        }

                                    </Flex>
                                    <Flex
                                        className={this.props.collapsed ? "chartLabels collapsed" : "chartLabels"}
                                        gap="gap.small"
                                        column
                                    >
                                        <Flex>
                                            <Box styles={{ backgroundColor: "#508BD5", width: ".5rem", height: "3rem", marginRight: "1.5rem", marginTop: ".5rem" }}></Box>
                                            <Flex column>
                                                <Text size={this.props.collapsed ? "medium" : "larger"} content={`${this.parseMetrics(this.props.metrics)?.atendimentosRealizados}%`} />
                                                <Text size="smaller" weight="bold" content={this.localize("TotalAtendimentos")} />
                                            </Flex>
                                        </Flex>

                                        <Flex>
                                            <Box styles={{ backgroundColor: "#FAD869", width: ".5rem", height: "3rem", marginRight: "1.5rem", marginTop: ".5rem" }}></Box>
                                            <Flex column>
                                                <Text size={this.props.collapsed ? "medium" : "larger"} content={`${this.parseMetrics(this.props.metrics)?.atendimentosAguardando}%`} />
                                                <Text size="smaller" weight="bold" content={this.localize("AguardandoAtendimento")} />
                                            </Flex>
                                        </Flex>

                                        <Flex>
                                            <Box styles={{ backgroundColor: "#ED1B23", width: ".5rem", height: "3rem", marginRight: "1.5rem", marginTop: ".5rem" }}></Box>
                                            <Flex column>
                                                <Text size={this.props.collapsed ? "medium" : "larger"} content={`${this.parseMetrics(this.props.metrics)?.atendimentosCancelados}%`} />
                                                <Text size="smaller" weight="bold" content={this.localize("AtendimentosExpirados")} />
                                            </Flex>
                                        </Flex>


                                    </Flex>
                                </Flex>
                            }
                        </>
                        :
                        <svg className="emptyChart" viewBox="0 0 550 550">
                            <rect y="37.7" width="88.7" height="414.6" />
                            <rect x="133.8" y="147.4" width="88.7" height="304.9" />
                            <rect x="267.6" y="235.7" width="88.7" height="216.6" />
                            <rect x="401.3" y="307.2" width="88.7" height="145.1" />
                        </svg>
                    }
                </Card.Body>
            </Box>
        );
    }
}

const visaoGeralAtendimentosWithTranslation = withTranslation()(VisaoGeralAtendimentosPorStatus);
export default visaoGeralAtendimentosWithTranslation;